export default __webpack_public_path__ + "static/media/delete_enable.ba8afee4.svg";